"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTimestamp;

function getTimestamp(seconds) {
  var hours = Math.floor(seconds / 3600);
  var minutes = Math.floor((seconds - hours * 3600) / 60).toFixed(0);
  var parsedSeconds = (seconds % 60).toFixed(0);
  return "".concat(hours, ":").concat(minutes.padStart(2, '0'), ":").concat(parsedSeconds.padStart(2, '0'));
}